<template>
  <div class="auth-page">
    <div class="auth-form">
      <a href="/" class="auth-page__a-logo">
        <img
          class="auth-page__logo"
          src="@/assets/media/logo.png"
          srcset="@/assets/media/logo@2x.png 2x"
        />
      </a>

      <div v-if="error" class="auth__error">{{ error }}</div>

      <template v-if="!resetSuccessful && resetCodeValid">
        <div class="auth-form__header">
          <i class="material-icons">vpn_key</i>
          <span>Create a new password</span>
        </div>

        <div class="field-wrapper">
          <i class="material-icons material-icon-input--16"> vpn_key </i>
          <input
            v-model="password"
            v-focus
            v-bind:class="{ 'input--not-valid': !passwordValid }"
            class="auth-form__password-input"
            :type="isPasswordVisible ? 'text' : 'password'"
            placeholder="new password"
            name="newpassword"
            @keydown.13="resetPassword"
          />
          <button
            type="button"
            class="auth-form__password-toggle"
            :aria-label="isPasswordVisible ? 'Hide password' : 'Show password'"
            :title="isPasswordVisible ? 'Hide password' : 'Show password'"
            data-test-id="btn-toggle-new-password"
            @click="isPasswordVisible = !isPasswordVisible"
          >
            <span class="material-icons">
              {{ isPasswordVisible ? 'visibility_off' : 'visibility' }}
            </span>
          </button>
        </div>

        <div class="field-wrapper">
          <i class="material-icons material-icon-input--16"> vpn_key </i>
          <input
            v-model="repeatPassword"
            v-bind:class="{ 'input--not-valid': !passwordsEqual }"
            class="auth-form__password-input"
            :type="isRepeatPasswordVisible ? 'text' : 'password'"
            placeholder="repeat password"
            name="repeatpassword"
            @keydown.13="resetPassword"
          />
          <button
            type="button"
            class="auth-form__password-toggle"
            :aria-label="isRepeatPasswordVisible ? 'Hide password' : 'Show password'"
            :title="isRepeatPasswordVisible ? 'Hide password' : 'Show password'"
            data-test-id="btn-toggle-repeat-password"
            @click="isRepeatPasswordVisible = !isRepeatPasswordVisible"
          >
            <span class="material-icons">
              {{ isRepeatPasswordVisible ? 'visibility_off' : 'visibility' }}
            </span>
          </button>
        </div>

        <button type="button" @click="resetPassword()">Create a new password</button>
      </template>

      <template v-if="resetSuccessful">
        <div>
          Password successfully changed, go to
          <router-link :to="{ name: 'login' }">Sign in</router-link>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import AuthAPI from 'api/auth';
  import PageTitle from '@/mixins/page-title';
  import { validatePassword } from 'utils/validators';

  const ErrorGeneral = 'An error occurred';
  const ErrorBadLink = 'Bad link';
  const ErrorNotEqualPassword = 'Passwords must be equal';
  const ErrorPasswordLength = 'Minimum length of password is 8 symbols';

  export default {
    name: 'ResetPasswordPage',
    mixins: [PageTitle],
    data() {
      return {
        pageTitle: 'HPLC Cloud: Reset password',

        resetCodeValid: false,
        resetCode: null,

        resetSuccessful: false,
        error: null,

        validatePassword: false,
        validateEqualPasswords: false,
        password: '',
        repeatPassword: '',
        isPasswordVisible: false,
        isRepeatPasswordVisible: false,
      };
    },
    computed: {
      passwordValid() {
        if (!this.validatePassword) {
          return true;
        }
        return validatePassword(this.password);
      },
      passwordsEqual() {
        if (!this.validateEqualPasswords) {
          return true;
        }
        return this.password === this.repeatPassword;
      },
    },
    mounted() {
      const { code } = this.$route.query;
      this.resetCode = code;
      this.checkResetCode();
    },
    methods: {
      checkResetCode() {
        if (!this.resetCode) {
          this.error = ErrorBadLink;
          return;
        }

        const onSuccess = (data) => {
          if (data && data.error) {
            this.error = data.error;
          } else {
            this.resetCodeValid = true;
          }
        };

        const onError = () => {
          this.error = ErrorBadLink;
        };

        AuthAPI.checkPasswordResetCode(this.resetCode, onSuccess, onError);
      },
      resetPassword() {
        this.error = null;
        this.validatePassword = false;
        this.validateEqualPasswords = false;

        if (!validatePassword(this.password)) {
          this.error = ErrorPasswordLength;
          this.validatePassword = true;
          return;
        }

        if (this.password !== this.repeatPassword) {
          this.error = ErrorNotEqualPassword;
          this.validateEqualPasswords = true;
          return;
        }

        const onSuccess = () => {
          this.resetSuccessful = true;
        };

        const onError = (data) => {
          if (data && data.error) {
            this.error = data.error;
          } else {
            this.error = ErrorGeneral;
          }
        };

        AuthAPI.resetPasswordByCode(this.resetCode, this.password, onSuccess, onError);
      },
    },
  };
</script>
